import { BordOneToneIcon } from 'components/NudosComponents';
import { redirectToConversation } from '../../utils/mentionsColumn.utils';

import './MentionSourceInfo.scss';

interface IMentionSourceInfoProps {
  icon: React.ReactNode;
  redirectText: string;
  isExpanded: boolean;
  redirectUrl: string;
}

export const MentionSourceInfo = ({ icon, redirectText, isExpanded, redirectUrl }: IMentionSourceInfoProps) => {
  const handleRedirectToConversation = (event: React.MouseEvent) => {
    event.stopPropagation();
    redirectToConversation(redirectUrl);
  };

  return (
    <div className="mentionSourceInfo">
      <div className="leftContent">
        {icon}
        <button className="redirectLink" onClick={handleRedirectToConversation}>
          <span className="redirectLinkText">{redirectText}</span>
          <BordOneToneIcon variant="arrowRight" stroke="#54a1fc" customWidth="12px" />
        </button>
      </div>

      <div className="rightContent">
        <BordOneToneIcon variant={isExpanded ? 'arrowHeadUp' : 'arrowHeadDown'} stroke="white" customWidth="12px" />
      </div>
    </div>
  );
};
